import { render, staticRenderFns } from "./strengthTab.vue?vue&type=template&id=4fd2cacc&scoped=true&"
import script from "./strengthTab.vue?vue&type=script&lang=js&"
export * from "./strengthTab.vue?vue&type=script&lang=js&"
import style0 from "./strengthTab.vue?vue&type=style&index=0&id=4fd2cacc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd2cacc",
  null
  
)

export default component.exports